module.exports = __webpack_public_path__ + "f881fd1f654891d9885ece26405df7d0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/afro-hair.png
// module id = 2149
// module chunks = 0